export const surgicalCenterFilterModal = {
	surgical_attendance_status: "",
	surgery_date: "",
	surgical_expertise_id: "",
	surgical_team_id: "",
	bed_status: "",
};
